import {format} from "date-fns";
import {TFunction} from "i18next";
import ResidentDetail from "../stores/domainStore/pages/models/residentDetail";
import {AppAccessStatus} from "./enums/appAccessStatus";
import {isIndependentPersonType, isServicedPersonType} from "./personTypeIds";

export class residentCsvExporterConfigs {
  static fileExtension: string = ".csv";
  static wrapColumnChar: string = '"';

  static getFileName(
    villageCode: string,
    namespace: string = "residentadmin"
  ): string {
    const departmentSegment =
      namespace === "saresidentadmin" ? "serviced_apartment" : "independent";
    return `${villageCode}_${departmentSegment}_${format(
      new Date(),
      "yyyyMMdd"
    )}`;
  }

  /**
   * Get column names for resident admin list
   * @param t translation function
   * @param namespace translation namespace for department-specific labels (e.g. unit code)
   * @returns a csv column name array
   */
  static getColumns(t: TFunction, namespace: string = "residentadmin"): any[] {
    return [
      {
        id: "lastname",
        displayName: t("residentadmin:labels.lastName")
      },
      {
        id: "firstName",
        displayName: t("residentadmin:labels.firstName")
      },
      {
        id: "preferredName",
        displayName: t("residentadmin:labels.preferredName")
      },
      {
        id: "area",
        displayName: t("residentadmin:labels.area")
      },
      {
        id: "unitCode",
        displayName: t(`${namespace}:labels.unitCode`)
      },
      {
        id: "appAccountEmail",
        displayName: t("residentadmin:labels.appAccountEmail")
      },
      {
        id: "appAccountStatus",
        displayName: t("residentadmin:labels.accountStatus")
      }
    ];
  }

  /**
   * Map resident to export row and replace all double quotes with two double quotes for CSV format
   * Also map enum to string
   */
  static mapResidentToExportRow = (resident: ResidentDetail) => {
    return {
      lastname: resident.lastName,
      firstName: resident.firstName,
      preferredName: resident.preferredName,
      area: residentCsvExporterConfigs.mapPersonTypeToArea(
        resident.personTypeId
      ),
      unitCode: resident.unitCode,
      appAccountEmail: resident.appAccountEmail,
      appAccountStatus: this.mapEnumToString(resident.appAccessStatus)
    };
  };

  static mapPersonTypeToArea = (personTypeId: string | undefined) => {
    if (!personTypeId) {
      return "";
    }
    if (isServicedPersonType(personTypeId)) {
      return "SA";
    }
    return isIndependentPersonType(personTypeId) ? "IA" : "";
  };

  static mapEnumToString = (value: AppAccessStatus | undefined) => {
    switch (value) {
      case AppAccessStatus.Active:
        return "Active";
      case AppAccessStatus.InActive:
        return "Inactive";
      case AppAccessStatus.Access:
        return "Access";
      default:
        return "Unknown";
    }
  };
}
